export const config = {
  appname: 'ecom',
  instagram: 'https://www.instagram.com/yoursocial/',
  youtube: 'https://www.youtube.com/@yoursocial',
  tiktok: 'https://www.tiktok.com/@yoursocial',
  x: 'https://x.com/yoursocial',
  discord: 'https://www.tiktok.com/@yoursocial',
  logo: '/Designs/PNG/512x156.png',
  smalllogo: '/Designs/PNG/500x500.png',
  userlogo: '/Designs/PNG/user-500x500.png',
  thumbdefault: 'https://www.contentviewspro.com/wp-content/uploads/2017/07/default_image.png',
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  server: window.location.hostname === 'localhost' ? 'http://localhost:8443' : 'https://api.ecom.com',
  client: window.location.hostname === 'localhost' ? 'http://localhost:1420' : 'https://www.ecom.com',
  isDevelopment: window.location.hostname === 'localhost',
  dns: '45.90.4.47',
};